import React, { useState } from 'react';

import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, message, Modal, Upload, UploadFile } from 'antd';
import { RcFile } from 'antd/es/upload';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { CreateImageParams, useCreateImageMutation } from 'features/imagesStore';

type FormData = CreateImageParams;

interface Props {
  handleCancel: () => void;
}

const CreateImageModal = ({ handleCancel }: Props) => {
  const [form] = Form.useForm<FormData>();
  const [selectedFile, setSelectedFile] = useState<UploadFile | null>(null);
  const [create, { isSuccess, isError, isLoading, error }] = useCreateImageMutation();


  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  const onFinish = () => {
    const formData = new FormData();
    formData.append('file', selectedFile as RcFile);

    create({ body: formData });
  };

  return (
    <Modal
      title={t('image-store.title.create')}
      onCancel={handleCancel}
      destroyOnClose
      open
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="edit-user__form"
      >
        <Form.Item
          name="body"
          label={t('image-store.label.file')}
          rules={[{
            required: true,
            message: t('image-stroe.errors.require-file')
          }]}
        >
          <Upload
            listType="picture"
            onRemove={() => setSelectedFile(null)}
            beforeUpload={(file) => {
              const isLt1M = file.size / 1024 / 1024 < 100;
              if (!isLt1M) {
                message.error(t('image-store.errors.file-size', { size: '1MB' }));
              }
              setSelectedFile(isLt1M ? file : null);
              return isLt1M ? false : Upload.LIST_IGNORE;
            }}
            action="/upload.do"
            fileList={selectedFile ? [selectedFile] : undefined}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <SubmiteButton submiteText={t('table.create')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};

export default CreateImageModal;
